const CORE_SIZE = {
  s0: "0rem",
  s4: "0.25rem",
  s8: "0.5rem",
  s12: "0.75rem",
  s16: "1rem",
  s20: "1.25rem",
  s24: "1.5rem",
  s28: "1.75rem",
  s32: "2rem",
  s36: "2.25rem",
  s40: "2.5rem",
  s44: "2.75rem",
  s48: "3rem",
  s52: "3.25rem",
  s56: "3.5rem",
  s60: "3.75rem",
  s64: "4rem",
  s68: "4.25rem",
  s72: "4.5rem",
  s76: "4.75rem",
  s80: "5rem"
};
const MAPPING_SIZE = {
  s: 32,
  m: 40,
  l: 48,
  xl: 56
};

export { CORE_SIZE, MAPPING_SIZE };
